import { render, staticRenderFns } from "./organizationRollCall.vue?vue&type=template&id=633d8708&scoped=true"
import script from "./organizationRollCall.vue?vue&type=script&lang=js"
export * from "./organizationRollCall.vue?vue&type=script&lang=js"
import style0 from "./organizationRollCall.vue?vue&type=style&index=0&id=633d8708&prod&lang=less"
import style1 from "./organizationRollCall.vue?vue&type=style&index=1&id=633d8708&prod&lang=less&scoped=true"
import style2 from "./organizationRollCall.vue?vue&type=style&index=2&id=633d8708&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d8708",
  null
  
)

export default component.exports